module.exports = __webpack_public_path__ + "img/ERROR404.8ee2e52e.svg";